import { createRoot } from 'react-dom/client';

import './assets/styles/app.sass';
import App from './app';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
